module.exports = __webpack_public_path__ + "img/nothingGreen.326ca3be.png";